<!-- main app container -->
<router-outlet></router-outlet>